export const REGISTRATION_URL_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.registration.url.v1+json';
import { DateTime } from 'luxon';

export class RegistrationUrl {
  public code: string;
  public url: string;
  public expires: DateTime;

  constructor(backEndRegistrationUrl?: BackendRegistrationUrl) {
    if (backEndRegistrationUrl) {
      this.code = backEndRegistrationUrl.code;
      this.url = backEndRegistrationUrl.url;
      this.expires = DateTime.fromISO(backEndRegistrationUrl.expires, { zone: 'utc' }).set({ hour: 23, minute: 59, second: 59 });
    }
  }
}

export interface BackendRegistrationUrlRequest {
  num_days: number;
}

export interface BackendRegistrationUrl {
  /** The registration code */
  code: string;

  /** The registration url */
  url: string;

  /** The registration expiry date */
  expires: string;
}
